import { injectable } from 'tsyringe';
import { getWebStoreApiClient } from '@gn-audio/core/auth';
import { createElement } from '@gn-audio/core/common/templating';
import { UipTranslationService } from '@/Feature/Uip/platform/app/services';
import { IUipMenuItem } from '@/Feature/Uip/platform/app/models';

import './uip-menu-item-logout.component.scss';

import template from './uip-menu-item-logout.component.html';

@injectable()
export class UipMenuItemLogoutComponent implements IUipMenuItem {
  private element?: Element;

  constructor(private readonly translationService: UipTranslationService) { }

  public destroy() {
    this.element?.removeEventListener('click', this.onLogout);
    this.element?.remove();
  }

  public async render(container: Element) {
    this.element = createElement(template, {}, await this.translationService.translations);
    this.element.addEventListener('click', this.onLogout);
    container.appendChild(this.element);
  }

  public shouldRender() {
    return true;
  }

  private onLogout = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    getWebStoreApiClient()
      .signOut();
  };
}
